module.exports = __webpack_public_path__ + "img/3.b71a4a98.png";